import { render, staticRenderFns } from "./codeLogin.vue?vue&type=template&id=99295a32&scoped=true&"
import script from "./codeLogin.vue?vue&type=script&lang=js&"
export * from "./codeLogin.vue?vue&type=script&lang=js&"
import style0 from "./codeLogin.vue?vue&type=style&index=0&id=99295a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99295a32",
  null
  
)

export default component.exports